import './Footer.css';
import React from "react";
import { Link } from 'react-router-dom';

function Footer(props) {
    return (
        <div className="footer">
                        <footer className="footerContainer">
                <nav>
                    <ul className="navItemList">
                        <li><Link className="navItem footerLinkText" to="/">Home</Link> | </li>
                        <li><Link className="navItem footerLinkText" to="/stories">Stories</Link> | </li>
                        <li><Link className="navItem footerLinkText" to="/fundamentals">Fundamentals</Link> | </li>
                        <li><Link className="navItem footerLinkText"  to="/connect">Connect</Link> | </li>
                        <li><Link className="navItem footerLinkText"  to="/printables">Printables</Link> | </li>
                    </ul>
                </nav>
                <div className="footerBottom">
                    <p className="footerText"> © 2026 Cerise Technology LLC </p>
                </div>
            </footer>
        </div>
    )
}

export default Footer;